/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createWebhusetOrderApiFeaturesCatalogVpsAddOnsGetResponseFromDiscriminatorValue, type WebhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /catalog/vpsaddons
 */
export interface VpsaddonsRequestBuilder extends BaseRequestBuilder<VpsaddonsRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<WebhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse>}
     */
     get(requestConfiguration?: RequestConfiguration<VpsaddonsRequestBuilderGetQueryParameters> | undefined) : Promise<WebhusetOrderApiFeaturesCatalogVpsAddOnsGetResponse | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<VpsaddonsRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
export interface VpsaddonsRequestBuilderGetQueryParameters {
    coupon?: string;
}
/**
 * Uri template for the request builder.
 */
export const VpsaddonsRequestBuilderUriTemplate = "{+baseurl}/catalog/vpsaddons{?coupon*}";
/**
 * Metadata for all the requests in the request builder.
 */
export const VpsaddonsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: VpsaddonsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        adapterMethodName: "send",
        responseBodyFactory:  createWebhusetOrderApiFeaturesCatalogVpsAddOnsGetResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
